.list {
  list-style: none;
  padding: 0;
  margin: 0;
  cursor: default;
  display: inline-block;
  border: 1px solid #888;
  border-radius: 2px;
}
